import React from "react";
import { useSearchParams } from "react-router-dom";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

import TableFilter from "components/Shared/AppTable/TableFilter";
import BaseAutocomplete from "components/Shared/Base/BaseAutocomplete";
import { useCustomParams } from "hooks/useCustomParams";
import ExportGeneralLedger from "./ExportGeneralLedger";

const SERVICE_CHARGE_PAYER_OPTIONS = [
  { label: "Vendor", value: "VENDOR" },
  { label: "Receiver", value: "RECEIVER" },
  { label: "Sender", value: "SENDER" },
  { label: "N/A", value: "N/A" },
];
const GL_ACCOUNT_OPTIONS = [
  { label: "BANK", value: "BANK" },
  { label: "SALES", value: "SALES" },
  { label: "CASH", value: "CASH" },
  { label: "COMPENSATION", value: "COMPENSATION" },
  { label: "RECEIVABLE from Vendors", value: "RECEIVABLE from Vendors" }, 
  { label: "RECEIVABLE from Customers", value: "RECEIVABLE from Customers" },
  { label: "PAYABLE to Vendors", value: "PAYABLE to Vendors" },
  { label: "PAYABLE to Customers", value: "PAYABLE to Customers" },
  { label: "Compensation on Loss/ Damage", value: "Compensation on Loss/ Damage" },
];
const GeneralLedgerFilter = () => {
  const { params, appendParams } = useCustomParams();
  const [searchParams] = useSearchParams();

  const keyword = searchParams.get("search") || "";
  const fromDate = params.fromDate || null;
  const toDate = params.toDate || null;
  const serviceChargePayer = params.serviceChargePayer || "";
  const glAccount = params.glAccount || "";
  const event = params.event || "";

  const selectedPayer = SERVICE_CHARGE_PAYER_OPTIONS.find(
    (o) => o.value === serviceChargePayer
  ) || null;

  const selectedGlAccount = GL_ACCOUNT_OPTIONS.find(
    (o) => o.value === glAccount
  ) || null;

  const filters = { keyword, fromDate, toDate, serviceChargePayer, glAccount, event };

  return (
    <TableFilter
      searchLabel="GL Number/Shipment/COC ID/COD ID/Delivery ID"
      initialFilters={2}
      actions={<ExportGeneralLedger filters={filters} />}
    >
      {/* From Date */}
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          label="From Date"
          value={fromDate ? moment(fromDate) : null}
          onChange={(val) =>
            appendParams({ fromDate: val ? val.format("YYYY-MM-DD") : "" })
          } 
          renderInput={(params) => (
            <TextField {...params} size="small" fullWidth />
          )}
          format="MM/DD/YYYY"
        />
      </LocalizationProvider>

      {/* To Date */}
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          label="To Date"
          value={toDate ? moment(toDate) : null}
          onChange={(val) =>
            appendParams({ toDate: val ? val.format("YYYY-MM-DD") : "" })
          }
          renderInput={(params) => (
            <TextField {...params} size="small" fullWidth />
          )}
          format="MM/DD/YYYY"
        />
      </LocalizationProvider>

      {/* Service Charge Payer */}
      <BaseAutocomplete
        fullWidth
        label="Service Charge Payer"
        options={SERVICE_CHARGE_PAYER_OPTIONS}
        getOptionLabel={(opt) => opt?.label || ""}
        isOptionEqualToValue={(option, value) => option?.value === value?.value}
        value={selectedPayer}
        onChange={(_, data) =>
          appendParams({ serviceChargePayer: data?.value || "" })
        }
      />
      <BaseAutocomplete
        fullWidth
        label="GL Account"
        options={GL_ACCOUNT_OPTIONS}
        value={selectedGlAccount}
        getOptionLabel={(opt) => opt?.label || ""}
        isOptionEqualToValue={(o, v) => o?.value === v?.value}
        onChange={(_, data) =>
          appendParams({
            glAccount: data?.value || "",
          })
        }
      />
      <TextField
        label="Event"
        value={event}
        size="small"
        fullWidth
        onChange={(e) =>
          appendParams({
            event: e.target.value,
          })
        }
      />

    </TableFilter>
  );
};

export default GeneralLedgerFilter;